<script lang="ts">
    import { getContext, createEventDispatcher, onMount } from 'svelte';

    import { editMoneyPlatformPayment } from '@api';

    import { profileContextKey } from '../context';

    const dispatch = createEventDispatcher()
    const profileContext = getContext(profileContextKey)
    const userId = profileContext.getUserId();
    const profile = profileContext.getProfile();

    let src = null;

    $: loading = true;

    const handleCreatePayment = async (data) => {
      if (!data) return;

      try {
        await editMoneyPlatformPayment(data.token, userId)
        dispatch('saved')
      } catch (error) {
        console.error('Setup payment method failed', error);
      }
    }

    const formatZipCode = (text) => {
      if(text) return text.replace(/(\d{5})(\d{4})/, '$1-$2')
    }
    
    const userFullName = profile?.givenName ? `${profile?.givenName} ${profile?.familyName}` : null;
    const paymentIframeConfig = {
    apiKey: 'process.env.MONEY_PLATFORM_API_KEY',
    title: 'Hagerty Drivers Club',
    defaultNewPaymentMethod: 'CREDIT',
    defaultBillingAddress: {
        line1: profile?.address?.addressLine1 || null,
        line2: profile?.address?.addressLine2 || null,
        state: profile?.province || null,
        city: profile?.city || null,
        zip: formatZipCode(profile?.address?.postalCode) || null,
    },
    defaultCardholderName: userFullName,
    hagertyAccountId: profile?.ghaid,
    savePaymentMethod: true,
    verifyOnly: true,
    onCreatePaymentMethod: handleCreatePayment
  };

  const loaded = () => {
    PaymentZoid(paymentIframeConfig).render('#money-platform');
    
    loading = false;
  }

  onMount(() => {
    src = 'process.env.MONEY_PLATFORM_URL';
  })
</script>

<svelte:head>
    {#if src}
      <script src={src} on:load={loaded}></script>
    {/if}
</svelte:head>

{#if loading}
    <p>Loading...</p>
{/if}

<div id="money-platform"></div>